import { defineStore } from "pinia";

const inFlight = new Map();

// Editor-tree collection cache. CollectionItemsPage production
// rendering resolves `pageEntities.collectionItems` (URL var
// `collection_id`) and lazy-fetches the collection record here through
// the page mixin.
export const useCollectionStore = defineStore("dynamic-component-editor-collection-store", {
  state: () => ({
    collections: {},
  }),
  actions: {
    async getOrFetchCollection(collectionId) {
      if (!collectionId) {
        return null;
      }
      const cached = this.collections?.[collectionId];
      if (cached?.collectionId || cached?.collection_id) {
        return cached;
      }
      if (inFlight.has(collectionId)) {
        return await inFlight.get(collectionId);
      }
      const promise = new Promise(resolve => {
        this.apiGet(
          `/collection/${collectionId}`,
          // The controller requires `item_context` + `item_id` as
          // collection-item disambiguators. We're rendering the
          // collection header on the CollectionItemsPage, not a
          // specific item, so pass the default context and a zero id.
          { item_context: "story", item_id: 0 },
          data => {
            if (!this.collections || typeof this.collections !== "object") {
              this.collections = {};
            }
            this.collections[collectionId] = data;
            resolve(data);
          },
          () => resolve(null),
        );
      }).finally(() => {
        inFlight.delete(collectionId);
      });
      inFlight.set(collectionId, promise);
      return await promise;
    },
  },
});
